module.exports = __webpack_public_path__ + "static/media/cntower.c2d90784.jpg";